import { render, staticRenderFns } from "./AlertOctagon.vue?vue&type=template&id=ca267964"
import script from "./AlertOctagon.vue?vue&type=script&lang=js"
export * from "./AlertOctagon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports